// extracted by mini-css-extract-plugin
module.exports = {"container":"pages_SearchResultsPage_container"};